exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".NotificationBanner-module__notificationRow___X6uR1 {\n  padding: 8px !important;\n}\n\n@media all and (min-width: 576px) {\n  .NotificationBanner-module__notificationRow___X6uR1 {\n    padding: 8px 0 !important;\n  }\n}", ""]);
// Exports
exports.locals = {
	"notificationRow": "NotificationBanner-module__notificationRow___X6uR1"
};